import React, { Component } from 'react'
import styled from 'styled-components'
import SignInForm from './SignInForm'
import SignUpForm from './SignUpForm'
import InvitationSignUpForm from './InvitationSignUpForm'

import { Switch, Route, Redirect } from 'react-router-dom'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`

class IdentificationPage extends Component {
  render() {
    const { location, loginHandler } = this.props
    return (
      <Container>
        <Switch>
          <Route path="/login" render={(props) => <SignInForm loginHandler={loginHandler} {...props}/>} />
          <Route path="/register" component={(props) => <SignUpForm loginHandler={loginHandler} {...props} />} />
          <Route path="/invitations/:invitationId" component={(props) => <InvitationSignUpForm loginHandler={loginHandler} {...props} />} />
          <Redirect to={{pathname: '/login', state: {from: location}}} />
        </Switch>
      </Container>
    )
  }
}

export default IdentificationPage



// WEBPACK FOOTER //
// ./src/pages/IdentificationPage/index.js